(function() {
  var tag = document.currentScript.dataset.tag || 'hautai-skinchat';
  var license_key = 'sclpk_U2EcE0rREt9UJPBu2nFqd0eI8Do07XhM';

  window.__skinchat = {
    chatId: document.currentScript.dataset.chatId || 'cht_CZHxZTiHKaZdzDdN',
    init(params) {
      return new Promise((resolve) => {
        window.addEventListener('DOMContentLoaded', () => {
          var checkAnalytics = setInterval(() => {
            if (
              typeof window.ShopifyAnalytics === 'undefined' ||
              !window.ShopifyAnalytics.lib ||
              !window.ShopifyAnalytics.lib.user
            )
              return;

            clearInterval(checkAnalytics);
            resolve(init());
          }, 100);
        });
      });

      function init() {
        var el = document.createElement(tag);

        el.setAttribute('chat', window.__skinchat.chatId);
        el.setAttribute('user', window.__user.id || ShopifyAnalytics.lib.user().traits().uniqToken);

        
        if(window.__skinchat.chatId == 'cht_qwnMKi5bXzeYzK1y') {
          license_key = 'sclpk_SNRG8YZ7cJ-Gt8Yl1jQx1PZqU1t0g47t';
        } else if ( window.__skinchat.chatId = 'cht_sWoDnLYJ0lGmk32W') {
          license_key = 'sclpk_X877BH6UPl5JZnWick9VaAP85Xa80';
        } else if ( window.__skinchat.chatId = 'cht_ggB8ZBqnQsYA0h0w') {
          license_key = 'sclpk_nKA0-GwaCB2Q3_KI3ipKOeLoVzGm_Fly';
        } else if ( window.__skinchat.chatId = 'cht_Gnc1wJ0RsguDBOnx') {
          license_key = 'sclpk_b0YoSWhRdAqe2iYagCXVgl1LeC8K8Y_N';
        } else if ( window.__skinchat.chatId = 'cht_dvieE8uvwvg2Ln3A') {
          license_key = 'sclpk_NGsbf5FkqwtBXNqRl6KsyGMMk8brfPsi';
        } else if ( window.__skinchat.chatId = 'cht_U1z0xFPWfFlREg1a') {
          license_key = 'sclpk_1CfWy736jjgR7FCc3sjddtMXAnQdAYff';
        } else if ( window.__skinchat.chatId = 'cht_da0w7PSKP7zvyH0Z') {
          license_key = 'sclpk_wK4cdKorWVgc6Pk5XcfmEfvJtFzi6yey';
        } else if ( window.__skinchat.chatId = 'cht_5nj0HRrflquxL0jH') {
          license_key = 'sclpk_NqoD-h8WK2WcNLQCk_gjCgo0u5COoGHw';
        } else if ( window.__skinchat.chatId = 'cht_BneIcsEzLuF2SzMo') {
          license_key = 'sclpk_pptC0e-SHQOGiztNOBlGfLpGJXHiusQ_';
        } else if ( window.__skinchat.chatId = 'cht_998q1nkV8zvBKvbr') {
          license_key = 'sclpk_Jx3bj0VOQxk_3JCIhOXdbtOFrnHjX4q4';
        } else if ( window.__skinchat.chatId = 'cht_auc54PvfiCgu1UQG') {
          license_key = 'sclpk_Rry1wcAdEbr5Se3PkQruZvxtvNYXPYil';
        } else if ( window.__skinchat.chatId = 'cht_6xaAaQy6mIl1WKJ1') {
          license_key = 'sclpk_YlpwwcYtDjy50qpBNvlLsTq7ur2nGOaH';
        } else if ( window.__skinchat.chatId = 'cht_6xaAaQy6mIl1WKJ1') {
          license_key = 'sclpk_YlpwwcYtDjy50qpBNvlLsTq7ur2nGOaH';
        }
        
        el.setAttribute('license-key', license_key);
        el.setAttribute('camera-target', 'body');

        el.addEventListener('favorite', (e) => {
          getFavorites().then((list) => {
            const updater = list.listcontents.some((item) => Number(item.epi) === Number(e.detail.id))
              ? _swat.removeFromWishList
              : _swat.addToWishList;

            updater({ epi: Number(e.detail.id), empi: Number(e.detail.vendorId), du: e.detail.url }, () =>
              updateFavorites(el),
            );
          });
        });

        el.addEventListener('cartadd', (e) => {
          if (params.onCartAdd) return params.onCartAdd(e);

          getCart()
            .then((cart) => {
              const isUpdate = cart.items.some((item) => String(item.id) === e.detail.id);

              return fetch(isUpdate ? '/cart/update.js' : '/cart/add.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify(
                  isUpdate ? { updates: { [e.detail.id]: e.detail.quantity } } : { items: [e.detail] },
                ),
              });
            })
            .then(() => {
              document.querySelector('cart-drawer')?.refresh();
              updateCart(el);
            });
        });

        updateCart(el);
        updateFavorites(el);

        params.target.appendChild(el);

        return el;
      }

      function getFavorites() {
        return new Promise((resolve, reject) => {
          var checkPlugin = setInterval(() => {
            if (typeof window._swat === 'undefined') return;

            clearInterval(checkPlugin);

            window._swat.fetchLists({
              callbackFn: (lists) => {
                var list = lists.find((l) => l.lty === 'wl');

                if (list) resolve(list);
                else reject(new Error('Wishlist not found'));
              },
            });
          }, 100);
        });
      }
      function updateFavorites(el) {
        getFavorites().then((list) => {
          el.setAttribute('favorites', JSON.stringify(list.listcontents.map((item) => String(item.epi))));
        });
      }
      function getCart() {
        return fetch('/cart.js').then((cart) => cart.json());
      }
      function updateCart(el) {
        if (!params.onCartAdd) getCart().then((cart) => {
          el.setAttribute('cart', JSON.stringify(cart.items.map((item) => ({ id: item.id, quantity: item.quantity }))));
        });
      }
    },
  };
})()